import React, {useContext, useEffect, useRef, useState} from "react";
import {BackendContext} from "../../../App";
import {
  Button, Divider,
  Input,
  InputRef,
  Modal,
  notification,
  Space,
  Spin,
  TableColumnsType,
  TableColumnType,
  TablePaginationConfig
} from "antd";
import {useNavigate} from "react-router-dom";
import {Paths} from "../../../Paths";
import {Messages} from "../../../backend/Messages";
import ClearBody from "../../../components/ClearBody";
import Title from "antd/es/typography/Title";
import PlayerInfoDTO from "../../../backend/models/player/PlayerInfoDTO";
import { SearchOutlined } from '@ant-design/icons';
import {FilterDropdownProps} from "antd/es/table/interface";
import Highlighter from "react-highlight-words";
import {Table} from "antd/lib";
import PaginationInfo from "../../../backend/models/PaginationInfo";
import PlayingPlayerRepresentationDTO from "../../../backend/models/player/PlayingPlayerRepresentationDTO";
import BreadcrumbSeparator from "antd/es/breadcrumb/BreadcrumbSeparator";
import Search, {SearchProps} from "antd/es/input/Search";



type NotificationType = 'success' | 'info' | 'warning' | 'error';


function PlayerViewingPage() {
  const backendContext = useContext(BackendContext);
  const [api, contextHolder] = notification.useNotification();
  const navigate = useNavigate();

  const [isModalOpen, setIsModalOpen] = useState(false);

  const [filterSteamId, setFilterSteamId] = useState("");
  const [filterBohId, setFilterBohId] = useState("");
  const [filterBeGuid, setFilterBeGuid] = useState("");
  const [filterProfile, setFilterProfile] = useState("");

  const [data, setData] = useState<PlayerInfoDTO[]>([]);
  const [paginationInfo, setPaginationInfo] = useState<PaginationInfo>({numberOfRecordsByPage: 10, pageNumber: 0, totalRecords: 0});


  type DataIndex = keyof PlayerInfoDTO;

  const columns: TableColumnsType<PlayerInfoDTO> = [
    {
      title: 'Id',
      dataIndex: 'id',
      key: 'id',
      width: '3%',
    },
    {
      title: 'SteamID',
      dataIndex: 'steamID',
      key: 'steamID',
      width: '10%',
    },
    {
      title: 'Boh ID',
      dataIndex: 'bohemianID',
      key: 'bohemianID',
      width: '15%',
    },
    {
      title: 'BE GUID',
      dataIndex: 'beGuid',
      key: 'beGuid',
      width: '15%',
    },
    {
      title: 'Is Premium',
      dataIndex: 'isPremium',
      render: (isPremium: boolean | undefined) => (isPremium ? "Yes" : "No"),
      key: 'isPremium',
      width: '5%',
    },
    {
      title: 'Last profile',
      dataIndex: 'lastSession',
      render: (lastSession: PlayingPlayerRepresentationDTO | undefined) => (lastSession ? `${lastSession.profileName}` : "N/A"),
      key: 'lastSession',
      width: '30%',
    },
  ];

  const openNotificationWithIcon = (type: NotificationType, title: string, description: string) => {
    api[type]({
      message: title,
      description: description,
    });
  };

  useEffect(() => {
    if (! backendContext.hasPlayerAuth()) {
      navigate(Paths.LoginSteamPage);
    }
  }, [backendContext, navigate]);

  const loadPlayers = (currentPage: number, pageSize: number) => {
    setIsModalOpen(true);
    backendContext.getPlayers(filterSteamId, filterBohId, filterBeGuid, null, filterProfile,pageSize, currentPage).then((playersResponse) => {
      setIsModalOpen(false);

      console.log(`Loaded players: ${JSON.stringify(playersResponse)}`);

      setData(playersResponse.players);
      setPaginationInfo(playersResponse.paginationInfo);
      openNotificationWithIcon("success", "Success", `${playersResponse.players.length} players loaded.`);

    }).catch((error) => {

      setIsModalOpen(false);
      openNotificationWithIcon("error", Messages.UnknownErrorTitle, Messages.UnknownErrorDescription + " " + JSON.stringify(error));
    });
  }

  const clickedLoad = () => {
    loadPlayers(0, 10);
  }

  const onChangeFilterSteamID = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => setFilterSteamId(e.target.value);
  const onChangeFilterBohID = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => setFilterBohId(e.target.value);
  const onChangeFilterBeGuid = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => setFilterBeGuid(e.target.value);
  const onChangeFilterProfile = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => setFilterProfile(e.target.value);


  return (
    <>
      {contextHolder}
      <ClearBody content={
        <div>
          <Title>Player listing</Title>
          <br />
          <Search placeholder="Filter steamID" onChange={onChangeFilterSteamID} value={filterSteamId} style={{ width: 200 }} />
          <Search placeholder="Filter bohID" onChange={onChangeFilterBohID} value={filterBohId} style={{ width: 200 }} />
          <Search placeholder="Filter be guid" onChange={onChangeFilterBeGuid} value={filterBeGuid} style={{ width: 200 }} />
          <Search placeholder="Filter profile" onChange={onChangeFilterProfile} value={filterProfile} style={{ width: 200 }} />
          <br />
          <br />
          <Button type="primary" style={{backgroundColor: "red"}} onClick={clickedLoad}>Load</Button>
          <Divider />
          <Table<PlayerInfoDTO> columns={columns} dataSource={data}  pagination={{pageSize: paginationInfo.numberOfRecordsByPage, current: paginationInfo.pageNumber+1, total: paginationInfo.totalRecords}}
          onChange={(pagination: TablePaginationConfig, filters, sorter, extra) => {
            if (pagination.current !== paginationInfo.pageNumber+1) {
              loadPlayers((pagination.current ?? 1) - 1, pagination.pageSize ?? 1);
            }
            if (pagination.pageSize !== paginationInfo.numberOfRecordsByPage) {
              loadPlayers((pagination.current ?? 1) - 1, pagination.pageSize ?? 1);
            }
          }}

          />


          <Modal open={isModalOpen} centered={true} closable={false}
                 okButtonProps={{ style: { display: 'none' } }}
                 cancelButtonProps={{ style: { display: 'none' } }}
          >
            <div style={{textAlign: "center"}}>
              <Spin size="large" />
            </div>
          </Modal>

        </div>
      } />
    </>
  );
}

export default PlayerViewingPage;